<!-- Tarjetas -->
<div class="max-w-7xl mx-auto my-10 grid grid-cols-1 md:grid-cols-4 gap-3">
    <!-- TODO: manejar como arreglo? -->
    <!-- Km recorridos -->
    <div
        class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-blue-500">
        <i class="pi pi-gauge text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-blue-500 dark:text-blue-500 font-bold text-sm">KM RECORRIDOS</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-[white]">{{ kmsRecorridosLabel }}</span>
        </div>
    </div>

    <!-- Combustible -->
    <div
        class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-green-400">
        <i class="pi pi-dollar text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-green-400 dark:text-green-400 font-bold text-sm">GASTO COMBUSTIBLE</p>

        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-[white]">{{ gastoCombustibleLabel }}</span>
        </div>
        <small class="mt-1 text-xs text-gray-500 dark:text-gray-300 text-center">{{ gastoCombustibleHint }}</small>
    </div>

    <!-- Vehiculos -->
    <div
        class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-cyan-500">
        <i class="pi pi-list text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-cyan-500 dark:text-cyan-500 font-bold text-sm">VEHICULOS EN OPERACIÓN</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-[white]">{{ vehiculosActivos }}/{{ vehiculosTotales }}</span>
            <span class="text-sm text-cyan-600 dark:text-cyan-400">({{ porcentajeOperacion }}%)</span>
            <div class="relative w-16 h-5 bg-gray-200 rounded-full overflow-hidden">
                <div class="absolute top-0 left-0 h-full bg-cyan-500 rounded-full" [style.width.%]="porcentajeOperacion"></div>
            </div>
        </div>
    </div>

    <!-- Flota en funcionamiento -->
    <div
        class="bg-white dark:bg-[#19191c] rounded-xl shadow-md p-6 flex flex-col items-center justify-center border-l-4 border-yellow-400">
        <i class="pi pi-car text-gray-400 dark:text-gray-50 text-3xl mb-2"></i>
        <p class="text-yellow-400 dark:text-yellow-400 font-bold text-sm">FLOTA EN MOVIMIENTO AHORA</p>
        <div class="mt-2 flex items-center space-x-2">
            <span class="text-xl text-gray-800 dark:text-[white]">{{ flotaFuncionandoAhora }}</span>
        </div>
        <small class="mt-1 text-xs text-gray-500 dark:text-gray-300 text-center">Unidades con GV activo en este momento</small>
    </div>

</div>